document.addEventListener('alpine:init', () => {

    window.Alpine.data('a11y', () => ({
        visible: false,
        lastY: 0,
        enabled: false,

        init() {
            // Only use scroll logic on mobile < 640px
            this.enabled = window.matchMedia('(max-width: 639px)').matches;

            if (!this.enabled) {
                this.visible = true; // desktop always visible
                return;
            }

            this.lastY = window.pageYOffset;
            window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        },

        onScroll() {
            const currentY = window.pageYOffset;

            if (currentY < this.lastY - 5) {
                // scrolling UP (threshold to avoid jitter)
                this.visible = true;
            } else if (currentY > this.lastY + 5) {
                // scrolling DOWN
                this.visible = false;
            }

            this.lastY = currentY;
        }
    }));

});
